import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { Phone } from '~components/AllianceCallService/AllianceCallService';

interface IProps {
    headingCopy: string;
    fromComponentName: string | undefined;
    btnStyle?: 'secondary' | 'link' | 'primary' | 'reskin' | 'orange' | 'rebrandAction' | undefined;
    textAlign?: 'left' | 'center' | 'right';
    phoneNumberTextStyle?: 'text-primary' | 'text-primary-dark';
    ttyFontWeight?: 'font-light' | 'font-extralight';
    icon?: string;
    hero?: boolean;
    tty?: boolean;
}

const SpeakWithAgent = ({
    headingCopy = 'Or speak with an eHealth licensed insurance agent',
    fromComponentName = undefined,
    btnStyle = 'secondary',
    textAlign = 'center',
    phoneNumberTextStyle = 'text-primary-dark',
    ttyFontWeight = 'font-light',
    icon,
    hero = false,
    tty = true,
}: PropsWithChildren<IProps>) => {
    let textExtraCssClass: string;
    let flexJustify: string;
    switch (textAlign) {
        case 'left': {
            textExtraCssClass = 'text-left';
            flexJustify = 'justify-start';
            break;
        }
        case 'right': {
            textExtraCssClass = 'text-right';
            flexJustify = 'justify-end';
            break;
        }
        default: {
            textExtraCssClass = 'text-center';
            flexJustify = 'justify-center';
            break;
        }
    }

    return (
        <section>
            {headingCopy && (
                <p
                    className={classNames(
                        'font-sans text-16 md:text-18 leading-24 md:leading-28',
                        textExtraCssClass
                    )}
                >
                    {headingCopy}
                </p>
            )}
            <div className="min-h-10 md:min-h-12 lg:min-h-14">
                {/* Mobile View */}
                <div className="block md:hidden mt-3 mb-6">
                    <Phone icon={icon} isbtn={btnStyle} fromComponentName={fromComponentName} />
                </div>
                {/* Tablet and Desktop Views */}
                <div className={classNames('hidden md:flex', flexJustify)}>
                    <Phone
                        classname={classNames(
                            'font-poppins font-bold text-20 leading-7 md:text-40 md:leading-56',
                            hero && ' lg:text-56 lg:leading-64',
                            phoneNumberTextStyle
                        )}
                        fromComponentName={fromComponentName}
                        icon={icon}
                    />
                    <span
                        className={classNames(
                            'font-poppins md:text-32 lg:text-40 md:leading-48 lg:leading-56 ml-3',
                            ttyFontWeight,
                            tty ? '' : 'sr-only'
                        )}
                    >
                        TTY 711
                    </span>
                </div>
            </div>
        </section>
    );
};

export default SpeakWithAgent;
